module.exports = __webpack_public_path__ + "img/user-active.5238a36c.svg";